import RecomendacionCard from "./RecomendacionCard"

const Recomendaciones = () => {
  const recomendaciones = [
    "Llegar a horario 20hs.",
    "Tener el código QR con anterioridad a la fiesta (descargado, en captura o impreso).",
    "El código QR generado debe ser en fondo blanco y NO con fondo oscuro, puesto que dificulta su lectura. En caso de haberlo descargado con fondo oscuro recomendamos descargar nuevamente antes del evento pero con fondo blanco.",
    "Avisar en las oficinas con anterioridad el deseo de unirse con otra familia, al igual que si alguno de los concurrentes es celiaco, vegetariano o intolerante a algún alimento.",
    "Informar si hay niños menores de 3 años y retirar tarjeta correspondiente presentando D.N.I.",
    "Todas las tarjetas que no se usen se devuelve la totalidad del dinero, pero se prohíbe la venta de tarjetas entre compañeros. Se suspenderá la venta en los 5 días previos a la fiesta.",
    "Los descuentos que se realicen por cualquier circunstancia. Se realizarán según criterio del personal administrativo del salón, previa presentación de C.U.D.",
    "El salón no se responsabiliza por perdidas de objetos personales en la fiesta.",
  ]

  return (
    <div className="recomendaciones-container">
      <div className="section-header">
        <h2 className="section-title">Recomendaciones</h2>
        <div className="divider"></div>
      </div>
      <RecomendacionCard>
        <div className="recommendations-list">
          {recomendaciones.map((item, index) => (
            <div key={index} className="recommendation-item">
              <div className="number-badge">{index + 1}</div>
              <p className="recommendation-text">{item}</p>
            </div>
          ))}
        </div>
      </RecomendacionCard>
    </div>
  )
}

export default Recomendaciones